import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { CardContent, Typography } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const thBase = { padding: '11px 10px', border: '1px solid #eee', fontSize: '0.95em' };
const tdBase = { padding: '11px 10px', border: '1px solid #eee' };
const headerRojo = {
  backgroundColor: '#c0000a',
  color: '#fff',
  fontWeight: 'bold',
  py: 1,
  letterSpacing: '.5px',
};

export default function Total({ data }) {

  const [visible, setVisible] = useState(false);

  const [trm, setTrm] = useState(null);
  const [trmError, setTrmError] = useState(false);

  useEffect(() => {
    fetch("https://consumos.talsa.com.co/api/talsa/pagina/trm", { cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        const t = Array.isArray(d) ? d[0] : d;
        setTrm({ USD: parseFloat(t.USD), EUR: parseFloat(t.EUR) });
      })
      .catch(() => setTrmError(true));
  }, []);

  const fmt = (n) => Number(n).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  const fechaHoy = () => {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return dd + " / " + mm + " / " + d.getFullYear();
  };

  const totals = {
    USD: 0, EUR: 0, COP: 0,
    USD1: 0, EUR1: 0, COP1: 0,
    USD2: 0, EUR2: 0, COP2: 0,
  };

  data.forEach((item) => {
    const currency = item.dtl.moneda;
    const valorBruto = parseFloat(item.dtl.valor * item.Cantidad);
    const valorNeto = parseFloat(Number((((item.descuento?.descuento * -1) / 100) - 1) * -1) * Number(Number(item.dtl.valor * item.Cantidad) + item.dtl.valor * item.iva * Number(item.Cantidad)));
    var valorDescuento = parseFloat(1 - Number((((item.descuento?.descuento * -1) / 100) - 1) * -1) * Number(Number(item.dtl.valor * item.Cantidad)) - Number(Number(item.dtl.valor * item.Cantidad)) * -1);
    totals[currency] += valorBruto;
    totals[currency + "1"] += valorNeto;
    totals[currency + "2"] += valorDescuento == 1 ? 0 : valorDescuento - 1;
    if (valorDescuento !== 1 && !visible) {
      setVisible(true);
    }
  });

  // Solo se muestra la conversion a pesos si el cliente es de Colombia (CO).
  const esColombia = String((data[0] && data[0].Pais) || 'CO').toUpperCase() === 'CO';

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={0.5} translate="no" style={{ padding: "20px" }}>

        <Grid item xs={12} translate="no">
          <Item sx={{ p: 0, overflow: 'hidden', borderRadius: '4px' }}>
            <Box sx={headerRojo}>VALORES TOTALES MONEDA DE ORIGEN</Box>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '1em' }}>
              <thead>
                <tr style={{ background: '#f3f3f3', color: '#555' }}>
                  <th style={{ ...thBase, textAlign: 'left' }}>Moneda</th>
                  <th style={{ ...thBase, textAlign: 'right' }}>Precio bruto</th>
                  {visible && <th style={{ ...thBase, textAlign: 'right' }}>Descuento</th>}
                  <th style={{ ...thBase, textAlign: 'right' }}>Precio con IVA</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { mon: 'USD', bruto: totals.USD, desc: totals.USD2, iva: totals.USD1 },
                  { mon: 'EUR', bruto: totals.EUR, desc: totals.EUR2, iva: totals.EUR1 },
                  { mon: 'COP', bruto: totals.COP, desc: totals.COP2, iva: totals.COP1 },
                ].map((f) => (
                  <tr key={f.mon}>
                    <td style={{ ...tdBase, textAlign: 'left' }}><b>{f.mon}</b></td>
                    <td style={{ ...tdBase, textAlign: 'right' }}>{fmt(f.bruto)}</td>
                    {visible && <td style={{ ...tdBase, textAlign: 'right' }}>{f.desc.toFixed(2) == 0 ? '-' : fmt(f.desc)}</td>}
                    <td style={{ ...tdBase, textAlign: 'right' }}>{fmt(f.iva)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Item>
        </Grid>

        {esColombia && (
        <Grid item xs={12} translate="no">
          <Item sx={{ p: 0, overflow: 'hidden', borderRadius: '4px', mt: 1 }}>
            <Box sx={headerRojo}>CONVERSIÓN A PESOS &mdash; TASA DE CAMBIO DEL DÍA</Box>
            {trmError ? (
              <Box sx={{ p: 2, color: '#c0000a' }}>No fue posible consultar la tasa de cambio del día. Intente recargar el enlace.</Box>
            ) : !trm ? (
              <Box sx={{ p: 2, color: '#888' }}>Consultando tasa de cambio del día...</Box>
            ) : (
              <Box sx={{ p: 0 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '1em' }}>
                  <thead>
                    <tr style={{ background: '#f3f3f3', color: '#555' }}>
                      <th style={{ ...thBase, textAlign: 'left' }}>Moneda origen</th>
                      <th style={{ ...thBase, textAlign: 'right' }}>TRM del día (COP)</th>
                      <th style={{ ...thBase, textAlign: 'right' }}>Precio bruto (COP)</th>
                      <th style={{ ...thBase, textAlign: 'right' }}>Precio con IVA (COP)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { mon: 'USD', tasa: trm.USD, bruto: totals.USD, iva: totals.USD1 },
                      { mon: 'EUR', tasa: trm.EUR, bruto: totals.EUR, iva: totals.EUR1 },
                    ].filter((f) => f.bruto !== 0 || f.iva !== 0).map((f) => (
                      <tr key={f.mon}>
                        <td style={{ ...tdBase, textAlign: 'left' }}>{f.mon}</td>
                        <td style={{ ...tdBase, textAlign: 'right' }}>{fmt(f.tasa)}</td>
                        <td style={{ ...tdBase, textAlign: 'right' }}>{fmt(f.bruto * f.tasa)}</td>
                        <td style={{ ...tdBase, textAlign: 'right' }}>{fmt(f.iva * f.tasa)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: '#fbe9e9', fontWeight: 'bold', color: '#c0000a' }}>
                      <td style={{ ...tdBase, padding: '10px' }} colSpan={2}>GRAN TOTAL CONSOLIDADO EN COP</td>
                      <td style={{ ...tdBase, padding: '10px', textAlign: 'right' }}>{fmt(totals.USD * trm.USD + totals.EUR * trm.EUR + totals.COP)}</td>
                      <td style={{ ...tdBase, padding: '10px', textAlign: 'right' }}>{fmt(totals.USD1 * trm.USD + totals.EUR1 * trm.EUR + totals.COP1)}</td>
                    </tr>
                  </tfoot>
                </table>
                <Typography sx={{ color: '#c0000a', fontWeight: 'bold', fontSize: '0.95em', textAlign: 'left', p: 1 }}>
                  Precio aplicable exclusivamente para el día {fechaHoy()}
                </Typography>
              </Box>
            )}
          </Item>
        </Grid>
        )}

        <Grid item xs={12} translate="no">
          <Item sx={{ p: 0, overflow: 'hidden', borderRadius: '4px', mt: 1 }}>
            <Box sx={headerRojo}>OFERTA DE MANTENIMIENTO PREVENTIVO</Box>
            <Box sx={{ p: 2, textAlign: 'left', color: '#333' }}>
              <Typography sx={{ fontWeight: 'bold', fontSize: '1.15em', mb: 1 }}>&iexcl;Asegura el rendimiento de tu equipo y ahorra!</Typography>
              <Typography sx={{ fontSize: '1em', mb: 1 }}>Aprovecha un beneficio exclusivo incluido en esta propuesta para tu próximo Mantenimiento Preventivo:</Typography>
              <Box component="ul" sx={{ m: 0, pl: 3, fontSize: '1em' }}>
                <li><b>15% de DESCUENTO</b> en Mano de Obra.</li>
                <li><b>10% de DESCUENTO</b> en Repuestos originales.</li>
              </Box>
              <Typography sx={{ fontSize: '1em', mt: 1, fontStyle: 'italic' }}>Evita fallas costosas y alarga la vida útil de tus equipos hoy mismo.</Typography>
            </Box>
          </Item>
        </Grid>

        {data.length > 0 && data[0].comentario !== "" && (
          <>
            <Grid item xs={12}>
              <Item><b>Nota:</b><br /></Item>
            </Grid>
            <Grid item xs={12} md={12}>
              <CardContent>
                <Typography variant='h6' style={{ fontSize: "0.8em", margin: "20px", overflowWrap: "break-word" }}>
                  {data[0].comentario}
                </Typography>
              </CardContent>
            </Grid>
          </>
        )}

      </Grid>
    </Box>
  );
}
